module.exports = __webpack_public_path__ + "img/winter-gloves.1e7108d1.png";